module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cooperation_banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("服务商火热招募中\n\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t领跑云打印行业，用智能让您一应俱全\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-primary",
    attrs: {
      "href": "javascript:void(0);",
      "role": "button",
      "data-toggle": "modal"
    }
  }, [_vm._v("成为代理商")])]), _vm._v(" "), _c('div', {
    staticClass: "coopti2_bg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.8s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.8s"
    }
  }, [_c('p', {
    staticClass: "tit_h1"
  }, [_vm._v("\n\t\t\t\t\t\t低门槛\n\t\t\t\t\t\t"), _c('span', [_vm._v("+")]), _vm._v("小投入\n\t\t\t\t\t\t"), _c('span', [_vm._v("+")]), _vm._v("大市场\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', [_vm._v("只要您愿意与我们共同发展")]), _vm._v(" "), _c('span', [_vm._v("成为代理商")]), _vm._v(" "), _c('span', [_vm._v("百亿级蓝海市场")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "npagePage cooperation"
  }, [_c('div', {
    staticClass: "cooperation_page3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("我们的优势")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "margin-right": "-30px",
      "margin-left": "-30px",
      "margin-top": "50px",
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("市场领先优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("众联云科技是国内最早的云打印服务提供商之一，客户遍布全国各地。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.3s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("服务优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cooperation_page3_img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tc"
  }, [_c('br'), _vm._v("厂家官方统一售后，快速响应，专业售后，代理无后顾之忧。\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.6s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("无需电脑、无需手机、无需驱动、无需人工，全自动接单。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("美团、饿了么、饿百多店铺全部自动接单。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("三重技术保障，彻底杜绝漏单。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caption_div"
  }, [_c('p', [_vm._v("一重保障：断电自动重打，防止因断电导致的漏单;")]), _vm._v(" "), _c('p', [_vm._v("二重保障：掉线自动换网，防止因设备掉线导致的漏单;")]), _vm._v(" "), _c('p', [_vm._v("三重保障：真人语音提醒，防止因人为原因导致的漏单。")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("高速打印头加自动切刀，高峰时段轻松应对。\n\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.9s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.9s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("众联云品牌优势")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row advantage"
  }, [_c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("市场优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("众联云科技是最早的外卖小票云打印服务提供商之一，客户遍布全国各地。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("技术领先")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("软件、硬件均自主研发，坐享珠三角完整产业链支撑，确保技术持续领先市场。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon3"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("品质可靠")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("自主工厂生产，12道工序严格检验，通过3C认证，质量可靠。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon4"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("服务高效")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("专业售后，7*24快速响应。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon5"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("云端稳定")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("采用腾讯云服务器，经过五年市场考验，性能稳定。")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cooperation_page4"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("代理政策")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row mt30"
  }, [_c('div', {
    staticClass: "tit wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t代理商应具备资源")]), _vm._v(" "), _c('div', {
    staticClass: "page4_img wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cooppage4_img1.png",
      "alt": "自动接单打印机"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tit wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t众联云厂家给予八大支持")]), _vm._v(" "), _c('div', {
    staticClass: "page4_img page4_img2 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp",
      "margin": "50px 120px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cooppage4_img2.png",
      "alt": "自动接单打印机"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-219e9300"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shareContent.vue
// module id = 327
// module chunks = 1